var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeFlatKuchSides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_26713)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_903_26713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.96 180.125L162.109 114.803L133.608 26.7942L52.9501 4.09344L0.803695 69.4053L29.3017 157.424L109.96 180.125Z",
    fill: "url(#paint0_linear_903_26713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9558 4.38099L62.0534 1.35202L142.711 24.0527L133.613 27.0817L52.9558 4.38099Z",
    fill: "#D18E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.616 27.0803L142.713 24.0513L171.215 112.06L162.117 115.089L133.616 27.0803Z",
    fill: "#F2B300"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_903_26713",
    x1: 139.715,
    y1: 150.37,
    x2: 23.1946,
    y2: 33.8489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176649,
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_26713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_903_26713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245.634,
    height: 174.645,
    fill: "white",
    transform: "translate(109.664 237.987) rotate(-135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeFlatKuchSides);
export default __webpack_public_path__ + "static/media/Type=Flat_Kuch_Sides.aa03388d6e96bfcf0b9f483b448d185b.svg";
export { ForwardRef as ReactComponent };